/* eslint-disable react-native-a11y/has-valid-accessibility-role */
import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Platform from "react-native-web/dist/exports/Platform";
import { withLinkRouter } from '../utils';
import ExpandCollapse from '../ExpandCollapse';
import ListboxItem from './ListboxItem';
import { useListboxContext } from './ListboxContext';
import GroupControl from './GroupControl';
import { jsx as _jsx } from "react/jsx-runtime";
const styles = StyleSheet.create({
  groupWrapper: {
    margin: 0,
    padding: 0,
    overflow: 'hidden'
  },
  list: {
    margin: 0,
    padding: 0
  }
});
const getAccessibilityRole = () => Platform.select({
  ios: 'listitem',
  android: 'none',
  web: 'listitem'
});
const ListboxGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    label,
    items,
    LinkRouter,
    linkRouterProps,
    expandProps,
    onLastItemBlur,
    nextItemRef,
    prevItemRef
  } = _ref;
  const {
    selectedId
  } = useListboxContext();

  // TODO: implement keyboard navigation via refs for grouped items separately here
  return /*#__PURE__*/_jsx(View, {
    id: "test",
    style: styles.groupWrapper,
    accessibilityRole: getAccessibilityRole(),
    children: /*#__PURE__*/_jsx(ExpandCollapse.Panel, {
      panelId: id ?? label,
      controlTokens: {
        icon: null,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        textLine: 'none',
        borderWidth: 0
      }
      // TODO refactor
      // eslint-disable-next-line react/no-unstable-nested-components
      ,
      control: controlProps => /*#__PURE__*/_jsx(GroupControl, {
        id: id ?? label,
        ...controlProps,
        label: label
      }),
      ...expandProps,
      tokens: {
        contentPaddingLeft: 0,
        contentPaddingRight: 0,
        contentPaddingTop: 0,
        contentPaddingBottom: 0,
        borderColor: 'transparent',
        borderRadius: 0,
        borderWidth: 0,
        marginBottom: 0
      },
      controlRef: ref,
      children: /*#__PURE__*/_jsx(View, {
        style: styles.list,
        children: items.map((item, index) => {
          return /*#__PURE__*/_jsx(ListboxItem, {
            id: item.id ?? item.label,
            ...item,
            selected: item.id && item.id === selectedId || item.label && item.label === selectedId,
            isChild: true,
            LinkRouter: LinkRouter,
            linkRouterProps: linkRouterProps,
            ...(index === 0 && {
              prevItemRef
            }),
            ...(index === items.length - 1 && {
              nextItemRef
            }),
            ...(index === items.length - 1 && {
              onBlur: onLastItemBlur
            })
          }, item.label);
        })
      })
    })
  });
});
ListboxGroup.displayName = 'ListboxGroup';
ListboxGroup.propTypes = {
  ...withLinkRouter.propTypes,
  label: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
    current: PropTypes.bool
  })),
  expandProps: PropTypes.object,
  nextItemRef: PropTypes.object,
  prevItemRef: PropTypes.object,
  /**
   * Use this callback to redirect the focus after it leaves the last item of the group.
   */
  onLastItemBlur: PropTypes.func
};
export default ListboxGroup;